import Masker from 'vanilla-masker';
import Axios from 'axios';

import HttpService from '../../infra/http/AxiosConfig';
import CancelablePromise from '../../functions/CancelablePromise';
import { formatMoney } from '../NumberService';
import FirebaseService from '../FirebaseService';
import OrderStatusEnum from '../../Enum/OrderStatusEnum';
import RolesEnum from '../../Enum/RolesEnum';
import OrigemEnum from '../../Enum/OrigemEnum';

const resource = 'pedidos';

const AxiosClient = Axios.create({
  baseURL: process.env.REACT_APP_API,
});

export const get = (
  page,
  pageSize,
  filter,
  status = undefined,
  startDate,
  endDate,
) => {
  let url = `${resource}/${page}/${pageSize}?filtro=${filter}`;

  if (startDate) url = `${url}&dataInicio=${startDate}`;
  if (endDate) url = `${url}&dataFim=${endDate}`;

  return CancelablePromise(
    HttpService.AxiosClient.get(
      `${url}${status ? status.reduce((x, y) => x + '&status=' + y, '') : ''}`,
    ),
  );
};

export const getOperationAutoComplete = (
  filter,
  status,
  onlyLate = false,
  date,
) => {
  const url = `${resource}/autocompletePorData/${date}?filtro=${filter}`;
  return CancelablePromise(
    HttpService.AxiosClient.get(
      `${url}${status ? status.reduce((x, y) => x + '&status=' + y, '') : ''}&somenteAtrasados=${onlyLate}`,
    ),
  );
};

export const getOperation = (
  page,
  pageSize,
  filter,
  status = undefined,
  onlyLate = false,
  date,
) => {
  const url = `${resource}/porData/${date}/${page}/${pageSize}?filtro=${filter}`;
  return CancelablePromise(
    HttpService.AxiosClient.get(
      `${url}${status ? status.reduce((x, y) => x + '&status=' + y, '') : ''}&somenteAtrasados=${onlyLate}`,
    ),
  );
};

export const getForFinances = ({
  page,
  pageSize,
  date,
  idOrganizacao = null,
}) => {
  const url = `${resource}/financas/${page}/${pageSize}`;
  return HttpService.AxiosClient.get(url, {
    params: { periodo: date, idOrganizacao },
  });
};

export const obterPedidosPeriodo = ({
  page,
  pageSize,
  date,
  idOrganizacao = null,
}) => {
  const url = `${resource}/financas-periodo/${page}/${pageSize}`;
  return HttpService.AxiosClient.get(url, {
    params: { periodo: date, idOrganizacao },
  });
};

export const getPedidosComDesconto = ({
  page,
  pageSize,
  revenda,
  organizacao,
  exportar = false,
}) => {
  const url = `${resource}/pedidos-com-desconto/${page}/${pageSize}?organizacao=${organizacao}&revenda=${revenda}&exportar=${exportar}`;
  return HttpService.AxiosClient.get(url);
};

export const getOrigem = (origem) => {
  switch (origem) {
    case OrigemEnum.App:
      return 'App';
    case OrigemEnum.Web:
      return 'Web';
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case OrderStatusEnum.Solicitado:
      return '#EFF6FF';
    case OrderStatusEnum.AceitoPeloAdm:
    case OrderStatusEnum.AceitoPeloFuncionarioUpgas:
    case OrderStatusEnum.AceitoPelaOrganizacao:
    case OrderStatusEnum.AceitoPeloMotorista:
      return '#FEFCE8';
    case OrderStatusEnum.FinalizadoPeloAdm:
    case OrderStatusEnum.FinalizadoPeloFuncionarioUpgas:
    case OrderStatusEnum.FinalizadoPelaOrganizacao:
    case OrderStatusEnum.FinalizadoPeloMotorista:
    case OrderStatusEnum.FinalizadoPeloCliente:
      return '#DCFCE7';
    case OrderStatusEnum.RejeitadoPeloAdm:
    case OrderStatusEnum.RejeitadoPeloFuncionarioUpgas:
    case OrderStatusEnum.RejeitadoPelaOrganizacao:
    case OrderStatusEnum.RejeitadoPeloMotorista:
      return '#595959';
    case OrderStatusEnum.CanceladoPeloAdm:
    case OrderStatusEnum.CanceladoPeloFuncionarioUpgas:
    case OrderStatusEnum.CanceladoPelaOrganizacao:
    case OrderStatusEnum.CanceladoPeloMotorista:
    case OrderStatusEnum.CanceladoPeloCliente:
      return '#E17052';
    case OrderStatusEnum.CanceladoPorTempoExcedido:
      return '#C95958';
    default:
      return '';
  }
};

export const getDashboardStatusText = (value) => {
  switch (value) {
    case OrderStatusEnum.Solicitado:
      return 'Solicitado';
    case OrderStatusEnum.AceitoPeloMotorista:
    case OrderStatusEnum.RejeitadoPeloMotorista:
    case OrderStatusEnum.CanceladoPeloMotorista:
    case OrderStatusEnum.FinalizadoPeloMotorista:
      return 'Motorista';
    case OrderStatusEnum.AceitoPeloAdm:
    case OrderStatusEnum.RejeitadoPeloAdm:
    case OrderStatusEnum.CanceladoPeloAdm:
    case OrderStatusEnum.FinalizadoPeloAdm:
      return 'Adm';
    case OrderStatusEnum.AceitoPeloFuncionarioUpgas:
    case OrderStatusEnum.RejeitadoPeloFuncionarioUpgas:
    case OrderStatusEnum.CanceladoPeloFuncionarioUpgas:
    case OrderStatusEnum.FinalizadoPeloFuncionarioUpgas:
      return 'Func. Upgas';
    case OrderStatusEnum.AceitoPelaOrganizacao:
    case OrderStatusEnum.RejeitadoPelaOrganizacao:
    case OrderStatusEnum.CanceladoPelaOrganizacao:
    case OrderStatusEnum.FinalizadoPelaOrganizacao:
      return 'Organização';
    case OrderStatusEnum.CanceladoPeloCliente:
    case OrderStatusEnum.FinalizadoPeloCliente:
      return 'Cliente';
    case OrderStatusEnum.CanceladoPorTempoExcedido:
      return 'Tempo Excedido';
    default:
      return '';
  }
};

export const getStatusText = (value) => {
  switch (value) {
    case OrderStatusEnum.Solicitado:
      return 'Solicitado';
    case OrderStatusEnum.AceitoPeloMotorista:
      return 'Aceito - Motorista';
    case OrderStatusEnum.AceitoPeloAdm:
      return 'Aceito - Adm';
    case OrderStatusEnum.AceitoPeloFuncionarioUpgas:
      return 'Aceito - Assistente Adm';
    case OrderStatusEnum.AceitoPelaOrganizacao:
      return 'Aceito - Org';
    case OrderStatusEnum.FinalizadoPeloMotorista:
      return 'Concluido - Motorista';
    case OrderStatusEnum.FinalizadoPelaOrganizacao:
      return 'Concluido - Org';
    case OrderStatusEnum.FinalizadoPeloAdm:
      return 'Concluido - Adm';
    case OrderStatusEnum.FinalizadoPeloFuncionarioUpgas:
      return 'Concluido - Assistente Adm';
    case OrderStatusEnum.FinalizadoPeloCliente:
      return 'Concluido - Cliente';
    case OrderStatusEnum.RejeitadoPeloMotorista:
      return 'Rejeitado - Motorista';
    case OrderStatusEnum.RejeitadoPelaOrganizacao:
      return 'Rejeitado - Org';
    case OrderStatusEnum.RejeitadoPeloAdm:
      return 'Rejeitado - Adm';
    case OrderStatusEnum.RejeitadoPeloFuncionarioUpgas:
      return 'Rejeitado - Assistente Adm';
    case OrderStatusEnum.CanceladoPeloAdm:
      return 'Cancelado - Adm';
    case OrderStatusEnum.CanceladoPeloFuncionarioUpgas:
      return 'Cancelado - Assistente Adm';
    case OrderStatusEnum.CanceladoPeloMotorista:
      return 'Cancelado - Motorista';
    case OrderStatusEnum.CanceladoPelaOrganizacao:
      return 'Cancelado - Org';
    case OrderStatusEnum.CanceladoPeloCliente:
      return 'Cancelado - Cliente';
    case OrderStatusEnum.CanceladoPorTempoExcedido:
      return 'Cancelado - Tempo Excedido';
    default:
      return '';
  }
};

export const apiRequestToForm = (result) => {
  const cliente = result.cliente || {};
  const produtos = Array.isArray(result.produtos) ? result.produtos : [];
  const historicoStatus = Array.isArray(result.historicoStatus)
    ? result.historicoStatus
    : [];

  return {
    id: result.idPedido,
    protocol: result.protocolo,
    customer: {
      name: cliente.nome || '',
      phone: cliente.telefone || '',
      originalPhone: cliente.telefoneOriginal || '',
      address: `${cliente.endereco || ''}${cliente.enderecoSecundario ? `, ${cliente.enderecoSecundario}` : ''}`,
      complement: cliente.complemento || '',
      localizacao: {
        latitude: cliente.latitude,
        longitude: cliente.longitude,
      },
      totalOrders: cliente.totalPedidos || 0,
      hasRecentCancellation: cliente.possuiCancelamentoRecente,
    },
    customerFiscalNoteDocument: result.documentoNotaFiscal
      ? Masker.toPattern(
        result.documentoNotaFiscal,
        result.documentoNotaFiscal.length > 11
          ? '99.999.999/9999-99'
          : '999.999.999-99',
      )
      : '',
    salesMan: buildSalesManObject(result),
    driver: buildDriverObject(result),
    product: result.produto,
    brand: result.marca,
    estimatedTime: result.tempoEstimado,
    quantity: result.quantidade,
    unitPrice: formatMoney(result.valorUnitario),
    price: formatMoney(result.valor),
    discount: formatMoney(result.valorDescontoSemCupom),
    taxaServico: formatMoney(result.taxaServico),
    taxaCancelamento: formatMoney(result.taxaCancelamento, { zeroCents: true }),
    descontoIndiqueGanhe: formatMoney(result.valorDescontoIndiqueGanhe),
    coupon: result.cupom
      ? {
        name: result.cupom?.nome,
        discount: formatMoney(result.cupom?.descontoLabel ?? 0),
      }
      : null,
    priceWithDiscount: formatMoney(result.valorComDesconto),
    change: formatMoney(result.valorTroco),
    paymentType: convertPaymentType(result.tipoPagamento),
    status: getStatusText(result.status),
    statusId: result.status,
    statusColor: getStatusColor(result.status),
    cancelReason:
      result.status === OrderStatusEnum.CanceladoPeloCliente
        ? result.motivoCancelamento
        : result.motivoCancelamentoRevenda,
    cancelReasonDescription: result.descricaoMotivoCancelamento,
    products: produtos,
    resaleName: result.revenda ? result.revenda.nome : '',
    resaleId: result.revenda?.id || '',
    driverId: result.motorista ? result.motorista.id : '',
    driverName: result.motorista ? result.motorista.nome : '',
    driverPhone: result.motorista ? result.motorista.telefone : '',
    tipoPedido: result.idTipoPedido,
    codigoConfirmacao: result.codigoConfirmacao,
    origem: result.origem,
    suspectedFraud: result.suspeitaFraude,
    averageDeliveryTime: result.tempoMedioEntrega,
    gasDoPovo: result.gasDoPovo,
    gasDoPovoValue: formatMoney(result.valorValeGasDoPovo),
    gasDoPovoDeliveryFee: formatMoney(result.taxaEntregaGasDoPovo),
    gasDoPovoUf: result.ufGasDoPovo,
    historicoStatus: historicoStatus.map((h) => {
      return {
        status: h.status,
        data: h.data,
        limiteEntrega: result.limiteEntrega,
        backofficeUserName: h.nomeUsuarioBackoffice,
      };
    }),
  };
};

const buildSalesManObject = (result) => {
  if (!result.vendedor) return undefined;

  return {
    name: result.vendedor.nome,
    phone: result.vendedor.telefone,
    localizacao: {
      latitude: result.vendedor.latitude,
      longitude: result.vendedor.longitude,
    },
  };
};

const buildDriverObject = (result) => {
  if (result.motorista) {
    return {
      name: result.motorista.nome,
    };
  }
  return undefined;
};

export const convertPaymentType = (value) => {
  switch (value) {
    case 1:
      return 'Dinheiro';
    case 2:
      return 'Débito';
    case 3:
      return 'Crédito';
    case 4:
      return 'PAGO PELO APP';
    case 5:
      return 'PIX';
    default:
      return '';
  }
};

export const find = (id) =>
  new Promise(async (resolve, reject) => {
    try {
      const result = await HttpService.AxiosClient.get(`${resource}/${id}`);
      const resale = apiRequestToForm(result);
      resolve(resale);
    } catch (error) {
      reject(error);
    }
  });

export const revealGasDoPovoCpf = (id) =>
  HttpService.AxiosClient.post(
    `${resource}/${id}/gas-do-povo/cpf/revelar`,
    {},
    {
      headers: {
        'Cache-Control': 'no-store',
        Pragma: 'no-cache',
      },
    },
  );

export const accept = (order, deliveryTime) =>
  new Promise(async (resolve, reject) => {
    try {
      await HttpService.AxiosClient.put(`${resource}/aceitar`, {
        idPedido: order.id,
        tempoEstimado: deliveryTime,
        motivoCancelamentoRevenda: order.motivoCancelamentoRevenda,
      });
      changeOrderStatus(
        order.id,
        OrderStatusEnum.AceitoPelaOrganizacao,
        deliveryTime,
      );
      markOrderAsReadByOrderId(order.id);
      resolve();
    } catch (error) {
      reject(error);
    }
  });

export const reject = (order) =>
  new Promise(async (resolve, reject) => {
    try {
      await HttpService.AxiosClient.put(`${resource}/rejeitar`, {
        idPedido: order.id,
        motivoCancelamentoRevenda: order.motivoCancelamentoRevenda,
        motivo: order.motivo,
      });
      changeOrderStatus(order.id, 7);
      return resolve();
    } catch (error) {
      return reject(error);
    }
  });

export const cancel = (order) =>
  new Promise(async (resolve, reject) => {
    try {
      await HttpService.AxiosClient.put(`${resource}/cancelarvendedor`, {
        idPedido: order.id,
        motivoCancelamentoRevenda: order.motivoCancelamentoRevenda,
        motivo: order.motivo,
        cancelarPorOrganizacao: order.cancelarPorOrganizacao || false,
      });

      changeOrderStatus(order.id, 9);
      return resolve();
    } catch (error) {
      return reject(error);
    }
  });

export const setDriver = (order, driverId) =>
  new Promise(async (resolve, reject) => {
    try {
      await HttpService.AxiosClient.put(`${resource}/transferirParaMotorista`, {
        idPedido: order.id,
        idMotorista: driverId,
      });

      return resolve();
    } catch (error) {
      return reject(error);
    }
  });

export const finish = (order, withCodeConfirmation) =>
  new Promise(async (resolve, reject) => {
    try {
      await HttpService.AxiosClient.put(`${resource}/finalizar`, {
        idPedido: order.id,
        codigoVerificacaoConfirmado: withCodeConfirmation,
      });

      changeOrderStatus(order.id, 5);
      return resolve();
    } catch (error) {
      return reject(error);
    }
  });

export const changeStatus = (order) =>
  new Promise(async (resolve, reject) => {
    try {
      await HttpService.AxiosClient.put(`${resource}/alterar-status`, {
        idPedido: order.idPedido,
      });
      return resolve();
    } catch (error) {
      return reject(error);
    }
  });

export const exportarRelatorioPedidosOrganizacao = ({
  dataInicio,
  dataFim,
  filtro,
  idOrganizacao,
}) => {
  const AxiosClient = Axios.create({ baseURL: process.env.REACT_APP_API });

  const authToken = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN);

  return AxiosClient.get(`${resource}\\exportarExcel`, {
    params: { dataInicio, dataFim, filtro, idOrganizacao },
    responseType: 'blob',
    headers: { Authorization: `Bearer ${authToken}` },
  });
};

export const watchResaleNewOrders = (id, role, callBack) => {
  return FirebaseService.firestore()
    .collection('pedidos')
    .where(role === RolesEnum.Resale ? 'ResaleId' : 'OrganizationId', '==', id)
    .where('Status', '==', 1)
    .onSnapshot((querySnapshot) => {
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      callBack(data);
    });
};

export const watchResaleCanceledOrders = (id, role, callBack) => {
  return FirebaseService.firestore()
    .collection('pedidos')
    .where(role === RolesEnum.Resale ? 'ResaleId' : 'OrganizationId', '==', id)
    .where('Status', '==', 9)
    .onSnapshot((querySnapshot) => {
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      callBack(data);
    });
};

export const markOrderAsRead = (documentId) => {
  return FirebaseService.firestore()
    .collection('pedidos')
    .doc(documentId)
    .update({ Read: true });
};

export const markOrderAsReadByOrderId = (orderId) => {
  FirebaseService.firestore()
    .collection('pedidos')
    .where('OrderId', '==', orderId)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        doc.ref.update({
          Read: true,
        });
      });
    });
};

const changeOrderStatus = (orderId, status, deliveryTime = '') => {
  FirebaseService.firestore()
    .collection('pedidos')
    .where('OrderId', '==', orderId)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        doc.ref.update({
          Status: status,
          Read: true,
          TimePrediction: deliveryTime,
        });
      });
    });
};

export const markAllOrderAsRead = (resaleId) => {
  FirebaseService.firestore()
    .collection('pedidos')
    .where('ResaleId', '==', resaleId)
    .where('Status', '==', 1)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function (doc) {
        doc.ref.update({
          Read: true,
        });
      });
    });
};

export const exportPedidosComDesconto = (revenda, organizacao) => {
  return AxiosClient.get(`${resource}/pedidos-com-desconto/0/0`, {
    params: { revenda, organizacao, exportar: true },
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN)}`,
    },
  });
};

export const exportPDFFile = (date, idOrganizacao = null) => {
  return AxiosClient.get(`${resource}/financas-periodo/0/0`, {
    params: { periodo: date, idOrganizacao: idOrganizacao, exportar: true },
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN)}`,
    },
  });
};

export const sendFileToEmail = (date, idOrganizacao = null) => {
  return AxiosClient.get(`${resource}/financas-periodo/0/0`, {
    params: {
      periodo: date,
      idOrganizacao: idOrganizacao,
      exportarEmail: true,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN)}`,
    },
  });
};
